import apiClient from '../apiClient';
import type { ApiResponse, Transaction, PaginationMeta } from '@/types';
import { getUrlWithQueryParams } from '@/lib/utils';
import { useQuery } from '@tanstack/react-query';
import { ReactQueryKeys } from '../reactQueryKeys';

const BASE_URL = '/dashboard/transactions';

interface PaginatedResponse {
  items: Transaction[];
  pagination: PaginationMeta;
}

export const getTransactions = async (
  page?: number,
  limit?: number,
  search?: string,
  sortBy?: string,
  sortOrder?: 'asc' | 'desc',
  machineId?: string,
  status?: string,
  dateFrom?: string,
  dateTo?: string
): Promise<PaginatedResponse> => {
  const url = getUrlWithQueryParams(BASE_URL, {
    page,
    limit,
    search,
    sortBy,
    sortOrder,
    machineId,
    status,
    dateFrom,
    dateTo,
  });
  const { data } = await apiClient.get<ApiResponse<Transaction[]>>(url);
  return {
    items: data.data,
    pagination: data.meta!,
  };
};

// React Query Hooks

export const useGetTransactions = (
  page?: number,
  limit?: number,
  search?: string,
  sortBy?: string,
  sortOrder?: 'asc' | 'desc',
  machineId?: string,
  status?: string,
  dateFrom?: string,
  dateTo?: string
) =>
  useQuery({
    queryKey: [ReactQueryKeys.GET_TRANSACTIONS, page, limit, search, sortBy, sortOrder, machineId, status, dateFrom, dateTo],
    queryFn: () => getTransactions(page, limit, search, sortBy, sortOrder, machineId, status, dateFrom, dateTo),
  });
